module.exports = __webpack_public_path__ + "img/app-preview-v2.938c81bb.png";